import { assign, choose, sendParent } from '@monofront/xstate-v4';
import { SELECT_SHIPPING_METHOD_TRANSITIONS } from '../transitions';
import { isHourSelected } from './guards';
import { SELECT_TIME_SLOTS_STATES } from './states';
import {
  ISelectDayEvent,
  ISelectHourEvent,
  ISelectTimeSlotsContext,
  ISelectTimeSlotsListResponseEvent,
} from './types';

export const sendSelectedTimeSlotToParent = sendParent<
  ISelectTimeSlotsContext,
  ISelectHourEvent
>((context) => ({
  type: SELECT_SHIPPING_METHOD_TRANSITIONS.SELECT_TIME_SLOT,
  timeSlotSelected: {
    deliveryDate: context.daySelected,
    timeSlot: context.hourSelected,
  },
}));

const sendSelectedTimeSlotFromDayChangedToParent = sendParent<
  ISelectTimeSlotsContext,
  ISelectDayEvent
>((context, event) => ({
  type: SELECT_SHIPPING_METHOD_TRANSITIONS.SELECT_TIME_SLOT,
  timeSlotSelected: {
    deliveryDate: event.daySelected,
    timeSlot: context.hourSelected,
  },
}));

export const assignSelectDay = assign<ISelectTimeSlotsContext, ISelectDayEvent>(
  {
    daySelected: (context, event) => event.daySelected ?? context.daySelected,
  },
);

export const assignSelectHour = assign<
  ISelectTimeSlotsContext,
  ISelectHourEvent
>({
  hourSelected: (context, event) => event.hourSelected ?? context.hourSelected,
});

export const assignClearSelection = assign<ISelectTimeSlotsContext, any>({
  daySelected: () => null,
  hourSelected: () => null,
});

export const assignSlotAvailabilitiesReceived = assign<
  ISelectTimeSlotsContext,
  ISelectTimeSlotsListResponseEvent
>({
  timeSlots: (_, event) => event.data.data.getSlotAvailabilitiesV2,
});

const sendSelectedTimeSlotToParentGuarded = choose([
  {
    actions: sendSelectedTimeSlotFromDayChangedToParent,
    cond: isHourSelected,
  },
]);

export const selectDayTransition = {
  target: SELECT_TIME_SLOTS_STATES.DAY_SELECTED,
  actions: [assignSelectDay, sendSelectedTimeSlotToParentGuarded],
};

export const selectHourTransition = {
  target: SELECT_TIME_SLOTS_STATES.HOUR_SELECTED,
  actions: [assignSelectHour],
};

export const clearSelectionTransition = {
  target: SELECT_TIME_SLOTS_STATES.GET_SUCCESS,
  actions: [assignClearSelection],
};
